import Vue from 'vue';
import App from './App.vue';
  
import '@/helpers/index';  
import '@/assets/scss/main.scss';
import '@/helpers/components/index';

import router from '@/router/index';
import store from '@/store/index'; 

import '@/plugins/element-ui';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');